module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "visualTesting.b8854283.png";